module.exports = __webpack_public_path__ + "static/media/resource-10.1e247e6d.png";